<form #scheduleForm="ngForm">
  <div id="schedule-tour-container" class="grid grid-cols-1">
    <div class="self-tour-step-header">
      <div class="text-xl font-denim-semibold">SCHEDULE YOUR TOUR</div>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-4">
      <mat-form-field class="my-2" hideRequiredMarker="true">
        <mat-label>Date</mat-label>
        <input matInput [matDatepicker]="selfTourPicker" name="selfTourDate" id="selfTourDate" required [(ngModel)]="model.TourDate" #TourDate="ngModel" [min]="minDateValue" [max]="maxDateValue">
        <mat-datepicker-toggle matSuffix [for]="selfTourPicker"></mat-datepicker-toggle>
        <mat-datepicker #selfTourPicker></mat-datepicker>
        <mat-error>Please fill out this field MM/DD/YYYY</mat-error>
      </mat-form-field>

      <mat-form-field class="my-2" hideRequiredMarker="true">
        <mat-label>Time</mat-label>
        <mat-select name="selfTourTime" id="selfTourTime" required [(ngModel)]="model.TourTime" #TourTime="ngModel">
          <mat-option *ngFor="let time of times" [value]="time.value">
            {{time.label}}
          </mat-option>
        </mat-select>
        <mat-error>Please fill out this field</mat-error>
      </mat-form-field>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-4">
      <mat-form-field class="my-2" hideRequiredMarker="true">
        <mat-label>Desired Move In Date</mat-label>
        <input matInput [matDatepicker]="desiredMoveInPicker" name="desiredMoveInDate" id="desiredMoveInDate" required [(ngModel)]="prospectInfo.PreferredMoveIn"#DesiredMoveInDate="ngModel" [min]="minDateValue" >
        <mat-datepicker-toggle matSuffix [for]="desiredMoveInPicker"></mat-datepicker-toggle>
        <mat-datepicker #desiredMoveInPicker></mat-datepicker>
        <mat-error>Please fill out this field MM/DD/YYYY</mat-error>
      </mat-form-field>
      <div class="flex justify-between">
          <mat-form-field class="my-2" hideRequiredMarker="true" style="width: 50%;">
            <mat-label>Household Gross Income</mat-label>
            <input matInput name="HouseholdGrossIncome" id="HouseholdGrossIncome" required matTooltip="Include all income streams for Household: Pay, Housing Vouchers, SSI, Alimony, Child Support, Etc"
              [(ngModel)]="incomeAmount" #HouseholdGrossIncome="ngModel" numberCeilingRounder>
            <mat-error>Please fill out this field</mat-error>
          </mat-form-field>
          <mat-form-field class="my-2" hideRequiredMarker="true" style="width: 45%;">
            <mat-label>Income Period</mat-label>
            <mat-select name="IncomePeriod" required [(ngModel)]="prospectInfo.IncomePeriod">
              <mat-option *ngFor="let ip of incomePeriods" [value]="ip.value">
                {{ip.label}}
              </mat-option>
            </mat-select>
          </mat-form-field>
      </div>
    </div>


    <div *ngIf="!isProcessing" class="flex justify-end">
      <div class="w-full sm:w-1/2">
        <div class="grid grid-cols-2 col-gap-4">
          <button mat-flat-button color="accent" (click)="back()">BACK</button>
          <button mat-flat-button color="accent" (click)="submit()" [disabled]="!scheduleForm.form.valid || isProcessing">NEXT</button>
        </div>
      </div>
    </div>
    <div *ngIf="isProcessing" class="flex justify-center"><mat-progress-spinner mode="indeterminate"></mat-progress-spinner></div>
  </div>
</form>
